import {css} from 'lit';
export const styles = css`:host {
  --background: var(--contrast-light);
  --background-active: var(--primary-200);

  /* the size of 1 absolute positioned icon: dot dot menu or restore for deleted */
  --padding-right: 45px;

  position: relative;
  display: block;
}

  :host([favoriteOn]) {
    /* the size of 2 absolute positioned icons: dot menu and favorite */
    --padding-right: 90px;
  }

/* add 16px of padding when screen is wider than mobile */

@media (min-width: 576px) {
  --padding-right: 61px;

  &([favoriteOn]) {
    --padding-right: 106px;
  }
}

:host(:not([url])),
a {
  display: block;
  width: 100%;
  padding: 16px var(--padding-right) 16px 16px;
  background-color: var(--background);
}

a {
  --link-text-active: var(--dark-text);
  --link-text-hover: var(--dark-text);
  --link-text: var(--dark-text);
  --link-focus-outline-offset: 0;
}

a:active {
    background-color: var(--background-active);
  }

main {
  width: 100%;
  display: flex;
  align-items: flex-start;
  min-width: 1px;
}

aside {
  position: absolute;
  top: 16px;
  right: 0;
  display: flex;
  align-items: center;
}

@media (min-width: 576px) {

aside {
    right: 16px
}
  }

ef-img-placeholder {
  min-width: 40px;
  margin-top: 4px;
  margin-right: 20px;
}

.info {
  display: flex;
  align-items: center;
  color: var(--gray-new-700);
  font-size: var(--bu-font-size-xs);
  min-width: -webkit-fit-content;
  min-width: -moz-fit-content;
  min-width: fit-content;
}

.type,
.role {
  --icon-font-size-primary: var(--bu-font-size-xs);
  --font-size-primary: var(--bu-font-size-xs);
  --text-primary: var(--gray-new-700);

  margin-top: 2px;

  margin-bottom: 2px;
  align-items: baseline;
}

.type {
  position: relative;
  margin-right: 16px;
}

.type::after {
    content: '';
    position: absolute;
    display: inline-block;
    background-color: var(--gray-new-600);
    height: 3px;
    width: 3px;
    border-radius: 50%;
    right: -10px;
    top: 6px;
  }

.members {
  white-space: nowrap;
}

bu-icon[name='star:solid'] {
  color: var(--secondary-new-500);
}

[name='title']::slotted(*) {
  font-weight: 700;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px !important;
}

@media (min-width: 786px) {

[name='title']::slotted(*) {
    -webkit-line-clamp: 1
}
  }
`;
export default styles;
